import React, { ChangeEvent, ReactNode } from 'react'

import Header from './Header'
import Footer from './Footer'
import { Themes } from './index.d'
import '../styles/main.scss'

interface ILayoutProps {
  children: ReactNode
}

interface ILayoutState {
  theme: Themes
}

class Layout extends React.Component<ILayoutProps, ILayoutState> {
  constructor(props: any) {
    super(props)

    this.state = {
      theme: null,
    }
    this.handleThemeUpdate = this.handleThemeUpdate.bind(this)
  }

  componentDidMount(): void {
    this.setState({ theme: window.__eaActiveTheme })
  }

  handleThemeUpdate = (event: ChangeEvent<HTMLInputElement>) => {
    const newTheme = (event.target.checked ? 'dark' : 'light') as Themes

    window.__setPreferredTheme(newTheme)
    this.setState({ theme: newTheme })
  }

  render() {
    return (
      <div id="app">
        <div className="site">
          <Header
            themeToggleHandler={this.handleThemeUpdate}
            activeTheme={this.state.theme}
          />
          <main className="site__main">{this.props.children}</main>
          <Footer />
        </div>
      </div>
    )
  }
}

export default Layout
